import Echo from "laravel-echo";
import io from "socket.io-client";
import { storage } from "../helpers/storage";

window.io = io;

const state = {
  connected: false,
  echo: null
};

const actions = {
  async initEcho({ commit }) {
    const hostname = window.location.hostname;
    const domain = hostname.endsWith('staging.ce-go.com')
      ? 'staging.ce-go.com'
      : hostname.endsWith('ce-go.l')
        ? 'local.ce-go.l'
        : 'sockets.ce-go.com';

    const token = await storage.getItem('token');

    if (!state.echo) {
      const echo = new Echo({
        broadcaster: 'socket.io',
        host: process.env.NODE_ENV === 'development'
          ? `${window.location.protocol}//${window.location.hostname}`
          : `${window.location.protocol}//${domain}`,
        transports: ['websocket', 'polling'],
        auth: {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      });

      echo.connector.socket.on('connect', () => {
        commit('setConnection', true);
      });

      echo.connector.socket.on('disconnect', () => {
        commit('setConnection', false);
      });

      commit('setEcho', echo);
      return echo;
    } else {
      state.echo.connector.options.auth.headers['Authorization'] = `Bearer ${token}`;
      commit('setEcho', state.echo);
      return state.echo;
    }
  },

  removeConnection({ commit, state }) {
    if (state.echo) {
      for (let channel in state.echo.connector.channels) {
        state.echo.leave(channel);
      }

      commit('setEcho', null);
    }
  },
};

const mutations = {
  setEcho(state, echo) {
    state.echo = echo
  },

  setConnection(status) {
    state.connected = status;
  },
};

const getters = {
  echo(state) {
    return state.echo;
  },

  connected(state) {
    return state.connected;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
